import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"



  
export default /*#__PURE__*/_defineComponent({
  __name: 'ChipElement',
  props: {
    selected: { type: Boolean },
    chip: null,
    optionLabel: null
  },
  emits: ["chipClicked"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'chipClicked', value: any, selected: boolean): void
  }), expose: any, slots: any, attrs: any }) {

const props = __props as {
    selected: boolean;
    chip: Record<string, any> | string;
    optionLabel?: string;
  };

  

  

  const chipClicked = (value: any) => {
    // const selected = props.selec
    emit('chipClicked', JSON.parse(JSON.stringify(value)), !props.selected);
  }


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`chip ${props.selected ? 'selected' : 'unselected'}`),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (chipClicked(__props.chip)))
  }, [
    _createElementVNode("span", null, _toDisplayString(typeof props.chip === 'string' ? props.chip : props.optionLabel ? props.chip[props.optionLabel] : props.chip), 1)
  ], 2))
}
}

})